import React from 'react'
import VoteButton from './VoteButton';

export default function Vote4(props) {
    const { themeData } = props;

    const handleStatus = () => {
        switch (themeData.win){
            case "none": return (themeData && themeData.type === "end" ? "vote-end" : "");
            case "16cha": return "winner-16cha";
            case "calpis": return "winner-calpis";
            case "same": return "draw";
            default: return "";
        }
    }

    return (<>
        <div className="round round4"></div>
        <div className="vote-title title4"></div>
        <div className="vote-desc">
            <div>烤肉局的下半場，好像有點乾啊~ 來點調酒暖場，讓氣氛更CHILL!</div>
            <div>來，這是酒單，請選擇!</div>
        </div>
        <div className={`vote-bg round4 ${handleStatus()}`}></div>
        <div className="vote-chat-container">
            <div className="vote-chat cha">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#梅香十六度</div>
                        <div className="desc">食穀清香與清爽梅香，搭配恰恰好的酒精濃度，調和成讓心情立馬放鬆的大人系微醺。</div>
                    </div>
                    <VoteButton voteType="cha" week="4">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
            <div className="vote-chat calpis">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#威可UP莎瓦</div>
                        <div className="desc">「可爾必思」酸甜初戀滋味，混搭威金森強烈氣泡與日式燒酌，烤肉氣氛 wake up，解渴不解嗨!</div>
                    </div>
                    <VoteButton voteType="calpis" week="4">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
        </div>
    </>)
}